import { useAppConstantsContext } from '@/context/AppConstants';
import {
  ReportSection,
  ThumbRatingContainer,
  RestoreAllDataButton,
} from '@/reports/index';
import { commonTypes, peopleTypes } from '@/reports/types/index';
import { Card } from '@/theme/index';
import { sortProfiles } from '@/utils/data';
import { ProfileCard, UsernameCard } from './SocialMediaCards';

export interface SocialMediaSectionProps {
  personName: string;
  usernames: commonTypes.Usernames;
  profiles: peopleTypes.Profiles;
  permalink: string;
}

export function SocialMediaSection({
  personName,
  usernames,
  profiles,
  permalink,
}: SocialMediaSectionProps) {
  const {
    data: { brandName },
  } = useAppConstantsContext();
  const sortedProfiles = sortProfiles(profiles);
  return (
    <ReportSection
      title="Possible Social Media"
      sectionDescription={`${brandName} runs a comprehensive search of the internet to uncover photos, social media profiles, blogs and websites that may potentially be associated with ${personName}.`}
      sectionId="social-media-section"
      hasContent={usernames.length > 0 || profiles.length > 0}
      personName={personName}
    >
      {!!usernames.length && (
        <Card sx={{ padding: 2.5 }} variant="outlined">
          {usernames.map(
            (username: commonTypes.Usernames[number], index: number) => (
              <UsernameCard
                key={`${index}-${username.username}`}
                username={username}
              />
            )
          )}
        </Card>
      )}

      {sortedProfiles.map((profile, index: number) => {
        return (
          <ThumbRatingContainer
            key={index}
            dataPropKey="profile"
            item={profile}
            component={ProfileCard}
            permalink={permalink}
            cardProps={{ ownerName: personName }}
          />
        );
      })}
      <RestoreAllDataButton items={sortedProfiles} permalink={permalink} />
    </ReportSection>
  );
}
